// extracted by mini-css-extract-plugin
module.exports = {"THEME_NAME":"\"fixtercore\"","Avatar":"Avatar_Avatar__plaFl","small":"Avatar_small__xkdfu","large":"Avatar_large__u0cJF"};